import { CVBuilderFormKeys, CVBuilderFormValues } from 'utils/cv-form-db';
import { CV_BUILDER_STEP_META, PROGRESS_STEPS, StepKey } from './stepMeta';

export const ZENJOB_LOGO_ALT_TEXT = 'Zenjob Pro Logo Purple';

/**
 * Step key → wire slug, derived from the single step table in `stepMeta.ts` so the slugs
 * (a pro-core `CvBuilderStep` contract) exist in exactly one place. Same shape as before,
 * so every `CV_BUILDER_STEPS.SUMMARY` / `CV_BUILDER_STEPS[key]` call site is unaffected.
 */
export const CV_BUILDER_STEPS = Object.fromEntries(
  CV_BUILDER_STEP_META.map(step => [step.key, step.slug])
) as Record<StepKey, string>;

export const defaultFormValues: CVBuilderFormValues = {
  language: '',
  personalDetails: {
    [CVBuilderFormKeys.INSURANCE_NAME]: '',
    [CVBuilderFormKeys.EMAIL]: '',
    [CVBuilderFormKeys.FIRST_NAME]: '',
    [CVBuilderFormKeys.LAST_NAME]: '',
    [CVBuilderFormKeys.PHONE]: '',
    [CVBuilderFormKeys.ZIP]: '',
    [CVBuilderFormKeys.INSURANCE_TYPE]: '',
    [CVBuilderFormKeys.WEEKLY_AVAILABLE_HOURS]: '',
    [CVBuilderFormKeys.STIPEND_BAFOEG]: ''
  },
  education: [],
  professionalExperience: [],
  hardSkills: [],
  softSkills: [],
  languageSkills: [],
  certificates: [],
  completedSteps: []
};

// Progress tracking configuration.
//
// Weights are derived from `stepMeta.countsTowardProgress`, which mirrors the backend's
// CvBuilderStep.countsTowardProgress (pro-core-service): both define the same 7-step
// denominator so the wizard's local progress matches the server's recordProgress
// percentage. Navigation-only steps get weight 0 on both sides.
const PROGRESS_STEP_WEIGHT = 100 / PROGRESS_STEPS.length; // ~14.29%

export const PROGRESS_CONFIG = {
  STEP_WEIGHTS: Object.fromEntries(
    CV_BUILDER_STEP_META.map(step => [
      step.key,
      step.countsTowardProgress ? PROGRESS_STEP_WEIGHT : 0
    ])
  ) as Record<StepKey, number>,
  // Mirrors theme palette; PRIMARY = Zenjob Blue. Prefer reading from the theme in
  // components — these literals exist only for any non-themed progress consumers.
  COLORS: {
    SUCCESS: '#22C55E',
    PRIMARY: '#2D31FF',
    WARNING: '#FFAB00',
    ERROR: '#FF5630'
  }
};
